function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgPrint(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M27,1a4,4,0,0,1,4,4V27a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V5A4,4,0,0,1,5,1H27m0-1H5A5,5,0,0,0,0,5V27a5,5,0,0,0,5,5H27a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
    style: {
      fill: "#bfce31"
    }
  }), React.createElement("path", {
    d: "M20.39,21.56h2.1A1.51,1.51,0,0,0,24,20.05v-5a1.52,1.52,0,0,0-1.51-1.52h-13A1.52,1.52,0,0,0,8,15.08v5a1.51,1.51,0,0,0,1.51,1.51h2.1",
    style: {
      fill: "none",
      stroke: "#6e7482",
      strokeMiterlimit: 10
    }
  }), React.createElement("rect", {
    x: 11.5,
    y: 18.45,
    width: 9,
    height: 5,
    style: {
      fill: "none",
      stroke: "#6e7482",
      strokeMiterlimit: 10
    }
  }), React.createElement("rect", {
    x: 11.5,
    y: 8.55,
    width: 9,
    height: 5,
    style: {
      fill: "none",
      stroke: "#6e7482",
      strokeMiterlimit: 10
    }
  }))));
}

export default __webpack_public_path__ + "static/media/print.92b25839.svg";
export { SvgPrint as ReactComponent };